WishlistButton = (() ->
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null
  init = ({csrf, wishlist}, done) ->
    $wishlistButton = $(".add-to-wishlist-btn")
    $wishlistButtonTextAdd = $(".add-to-wishlist-btn-text-add")
    $wishlistButtonTextRemove = $(".add-to-wishlist-btn-text-remove")
    $multiOptionBreakout = $(".multi-option-breakout input,.multi-option-overlay-list input")
    wishlistPayload = wishlist
    dealId = wishlist.dealUUID

    setSelectedItem wishlistPayload

    csrfToken = csrf
    listenToOptionSelection()

    $wishlistButton.on "click", (e) ->
      wishlistButtonClicked(e)
    $multiOptionBreakout.on "click", multiOptionBreakoutClicked

    done()

  setSelectedItem = ->
    if wishlistPayload.selectedOptionUUID
      selectedOptionUUID = wishlistPayload.selectedOptionUUID
    else
      selectedOptionUUID = null

  multiOptionBreakoutClicked = (e) ->
    target = $ e.target
    selectedOptionUUID = target.data "uuid"
    updateWishlistedNotifier selectedOptionUUID

  updateWishlistedNotifier = (optionUUID) ->
    $wishlistButton.removeClass "wishlisted"
    $wishlistButtonTextAdd.removeClass "hidden"
    $wishlistButtonTextRemove.addClass "hidden"
    currentItem = null

    currentItem = _.find(wishlistPayload.items, (item) ->
      item.optionId == optionUUID
    )

    if currentItem
      $wishlistButton.addClass "wishlisted"
      $wishlistButtonTextAdd.addClass "hidden"
      $wishlistButtonTextRemove.removeClass "hidden"
      wishlistPayload.removeItemUrl = currentItem.removeItemUrl
    currentItem

  listenToOptionSelection = ->
    window.DealEventPipe.on "priceUpdate", (priceData) ->
      $tooltip = $('#select-option-tooltip')
      GIG.Tooltip.close $tooltip
      selectedOptionUUID = if priceData.variationsSelected then priceData.uuid else null
      updateWishlistedNotifier selectedOptionUUID

  toggleWishlistButtonStyle = ->
    $wishlistButton.toggleClass "wishlisted"
    $wishlistButtonTextAdd.toggleClass "hidden"
    $wishlistButtonTextRemove.toggleClass "hidden"

  onAddItemSuccess = (data) ->
    selectedOptionUUID = null if !selectedOptionUUID

    addedItem =
      dealId: dealId,
      itemId: data.itemId,
      listId: data.listId,
      optionId: selectedOptionUUID,
      removeItemUrl: "/deals/wishlists_proxy/remove/#{data.listId}/#{data.itemId}"

    wishlistPayload.items.push addedItem
    wishlistPayload.removeItemUrl = addedItem.removeItemUrl
    toggleWishlistButtonStyle()

  addItemToWishlist = ->
    $wishlistButton.prop 'disabled', true
    $.ajax
      url: wishlistPayload.addItemUrl #"/deals/wishlists_proxy/addbyname?listName=default"
      dataType: "json"
      type: "POST"
      data:
        dealId: dealId
        optionId: selectedOptionUUID if selectedOptionUUID
        _csrf: csrfToken
      error: (jqxhr, textStatus, error) ->
        $(".wishlist-add-error").fadeIn().delay(3000).fadeOut()
      success: (data, status, xhr) ->
        onAddItemSuccess data
      complete: ->
        $wishlistButton.prop 'disabled', false

  removeItemFromWishlist = ->
    $wishlistButton.prop 'disabled', true
    $.ajax
      url: wishlistPayload.removeItemUrl #"/deals/wishlists_proxy/remove/763bc9b9-0a4e-4e1a-af6d-f63652f99b91/9b2c3e2c-1442-4779-a89e-ae3ed5eddc62"
      dataType: "json"
      type: "POST"
      data:
        _csrf: csrfToken
      error: (jqxhr, textStatus, error) ->
        $(".wishlist-remove-error").fadeIn().delay(3000).fadeOut()
      success: (data, textStatus, error) ->
        toggleWishlistButtonStyle()
        wishlistPayload.items = _.reject(wishlistPayload.items, (item) ->
          item.optionId == selectedOptionUUID
        )

      complete: ->
        $wishlistButton.prop 'disabled', false
        selectedOptionUUID = null

  wishlistButtonClicked = (e) ->
    if $wishlistButton.hasClass "wishlisted"
      removeItemFromWishlist()
    else
      addItemToWishlist()

  getSelectedUUID = ->
    selectedOptionUUID

  getRemoveItemUrl = ->
    wishlistPayload.removeItemUrl

  init: init
  onAddItemSuccess: onAddItemSuccess
  getSelectedUUID: getSelectedUUID
  getRemoveItemUrl: getRemoveItemUrl
)()

module.exports = WishlistButton
